import React from 'react';
import styles from "../heatmap/tooltip.module.css";

type USMapTooltipProps = {
    data: string[];
    position: { x: number; y: number };
    width: number;
    height: number;
};

export type USMapInteractionData = {
    data: string[];
    value: number;
    position: { x: number; y: number };
}

export const USMapTooltip: React.FC<USMapTooltipProps> = ({ data, position, width, height }) => {
    if (!data.length) {
        return null;
    }

    // console.log(width)

    return (
        <div
            style={{
                width,
                height,
                position: "absolute",
                top: 0,
                left: 0,
                pointerEvents: "none",
            }}
        >
            <div
                className={styles.tooltip}
                style={{
                    position: "absolute",
                    left: position.x,
                    top: position.y,
                }}
            >
                {data.map((item, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && <br />}
                        <span>{item}</span>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}; export default USMapTooltip;